import React, { useMemo, Fragment } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { Icon, BetStatus, BetCount } from 'components';
import Sidebar from '../Sidebar';
import useSidebarToggler from './useSidebarToggler';
import useBetslipInfo from './useBetslipInfo';
import arrowLeft from 'assets/svg/arrow-left.svg';
import globalMsgs from 'messages';
import './sidebarTogglerMob.scss';

interface Props {}

const SidebarTogglerMob: React.FC<Props> = () => {
    const { formatMessage } = useIntl();
    const {
        handleCloseSidebar,
        handleOpenSidebar,
        isSidebarOpen,
        isFullScreen,
        isAuthorized,
        isMedium,
    } = useSidebarToggler();
    const { betStatus, totalOdd, betsSize } = useBetslipInfo();

    const formattedOdd = totalOdd?.component;

    const renderCloseBtn = useMemo(
        () => (
            <div styleName="close-btn" onClick={handleCloseSidebar}>
                <div styleName="close-text">
                    {formatMessage(globalMsgs.hide)}
                </div>
                <Icon glyph={arrowLeft} styleName="close-icon" />
            </div>
        ),
        [handleCloseSidebar, formatMessage]
    );

    const renderBetslipInfo = useMemo(() => {
        if (betsSize === 0) return formatMessage(globalMsgs.bettingSlip);

        return (
            <div styleName="betslip-info">
                <BetCount betsSize={betsSize} />
                {formattedOdd && (
                    <div styleName="total-odd">
                        {formatMessage(globalMsgs.totalOdd) + ' '}
                        {formattedOdd}
                    </div>
                )}
            </div>
        );
    }, [formattedOdd, betsSize, formatMessage]);

    if (isFullScreen && isMedium) return null;

    return (
        <div styleName={cn('container', { 'is-full-screen': isFullScreen })}>
            {isSidebarOpen || (isFullScreen && !isMedium) ? (
                <Sidebar
                    isAuthorized={isAuthorized}
                    extraTab={isFullScreen ? <Fragment /> : renderCloseBtn}
                />
            ) : (
                <div styleName="open-btn" onClick={handleOpenSidebar}>
                    {renderBetslipInfo}
                    <Icon glyph={arrowLeft} styleName="icon" />
                    <BetStatus betStatus={betStatus} />
                </div>
            )}
        </div>
    );
};

export default SidebarTogglerMob;
